import React from 'react';
import { Link } from 'react-router-dom';
import { addToBrowsingHistory } from '../utils/dataManager';

const ProductCard = ({ product }) => {
  const handleClick = async () => {
    // 添加到浏览历史
    await addToBrowsingHistory(product.id);
  };

  return (
    <Link 
      to={`/product/${product.id}`} 
      className="card hover:shadow-lg transition-shadow duration-300"
      onClick={handleClick}
    >
      <div className="relative pb-[75%] max-h-[250px] overflow-hidden">
        <img
          src={product.imageUrl}
          alt={product.name}
          className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 bg-primary text-white text-xs px-2 py-1 rounded-full">
          {product.crystalType}
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-lg font-medium text-gray-800 mb-1 truncate">{product.name}</h3>
        <p className="text-primary font-bold">¥{product.price}</p>
      </div>
    </Link>
  );
};

export default ProductCard;